<div class="list-card">
  <div class="list-container">
    <!-- Main heading with icon -->
    <div class="heading" *ngIf="this.config?.header?.value">

      <h3 class="list-heading"><i class="fa fa-file heading-icon"></i> {{table_nm}}</h3>
    </div>

    <!-- Add and Print buttons -->
    <div class="button-container" *ngIf="this.config?.header?.value">
      <button mat-raised-button class="button-right add-button" (click)="onAddButtonClick()">


        <i class="fa fa-plus"></i> Add
      </button>
      <button mat-raised-button class="button-right print-button" (click)="onPrintAllClick()">
        <i class="fa fa-print"></i> Print All
      </button>
    </div>

    <!-- Mat card for functionalities -->


    <!-- Mat table in card -->
    <mat-card class="table-card">
      <mat-card class="functional-card">
        <div class="search-container">
          <mat-form-field class="search-field" *ngIf="tableview">
            <input matInput placeholder="Search" (keyup)="applyFilter($event.target.value)">
          </mat-form-field>
          <mat-form-field class="search-field" *ngIf="!tableview">
            <input matInput placeholder="Search" (keyup)="applyFiltermatcard($event.target.value)">
          </mat-form-field>
          <div class="function-buttons">
            <!-- <button  (click)="openFilterbyDialog()" class="filter-button">
              <i class="fa fa-filter"></i> Filter By
              <span class="filter-count">2</span>
            </button> -->
            <button mat-raised-button matBadge="{{ filterArr?.['or']?.length || 0 }}" matBadgeColor="accent"
              matBadgePosition="after" matBadgeSize="small"
              (click)="filterArr?.['or']?.length ? clearFilters() : openFilterbyDialog()">
              <i class="fa" [ngClass]="filterArr?.['or']?.length ? 'fa-times' : 'fa-filter'"></i>
              {{ filterArr?.['or']?.length ? 'Clear Filters' : 'Filter By' }}
            </button>


            <button mat-button (click)="openMultipleSortingDialog()">
              <i class="fa fa-sort"></i> Sort By
            </button>

            <button mat-button [matMenuTriggerFor]="menu" *ngIf="tableview">
              <i class="fa fa-columns"></i> Manage Columns
            </button>
            <button mat-button (click)="changeView()" *ngIf="cardsview">
              <i class="fa fa-th shadow mr-5 iconitem" aria-hidden="true" *ngIf="tableview"></i>&nbsp;
              <i class="fa fa-list shadow mr-5" aria-hidden="true" *ngIf="!tableview"></i>
            </button>



            <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
              <mat-list>
                <mat-list-item *ngFor="let column of allColumns">
                  <mat-checkbox [(ngModel)]="columnChecked[column]" (change)="toggleColumnVisibility(column)"
                    class="box">
                    {{ column }}
                  </mat-checkbox>
                </mat-list-item>
              </mat-list>
            </mat-menu>
          </div>
        </div>
      </mat-card>
      <mat-card class="search-card">

        <mat-table [dataSource]="dataSource" class="table mat-table-container" matSort *ngIf="tableview">
          <ng-container *ngFor="let col of displayedColumns">
            <ng-container *ngIf="col != 'action'" [matColumnDef]="col">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by number"> {{ col | titlecase }} </th>
              <span class="mobile-label">{{ col | titlecase }}:</span>
              <td mat-cell *matCellDef="let element"
                [ngClass]="{'text-align-right': isNumericType((this.datatypebytech[displayedColumnsObj[col]]).toLowerCase()), 'text-align-left': !isNumericType((this.datatypebytech[displayedColumnsObj[col]]).toLowerCase())}">
                {{element[displayedColumnsObj[col]]}} </td>
            </ng-container>
            <ng-container *ngIf="col == 'action'" [matColumnDef]="col">
              <th mat-header-cell *matHeaderCellDef> {{ col | titlecase }} </th>
              <span class="mobile-label">{{ col | titlecase }}:</span>
              <td mat-cell *matCellDef="let element">
                <i *ngIf="lr_type == 'REFERENCE' && (lr_hist == 'VH' || lr_hist == 'NH')" class="fa fa-eye tableicon"
                  (click)="onView(element)"></i>
                <i *ngIf="lr_type == 'REFERENCE' && (lr_hist == 'VH' || lr_hist == 'NH')" class="fa fa-edit tableicon"
                  (click)="onUpdate(element)"></i>
                <i *ngIf="lr_type == 'REFERENCE' && (lr_hist == 'VH' || lr_hist == 'NH')" class="fa fa-trash tableicon"
                  (click)="onDelete(element)"></i>

              </td>
            </ng-container>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </mat-table>
        <div class="container" *ngIf="!tableview">
          <mat-card *ngFor="let card of filteredData" class="example-card mat-elevation-z4">
            <div>
              <div class="row mainhead">{{ card?.[cardsObj?.mainHeading] }}</div>
              <div class="subtitle">{{ card?.[cardsObj?.subHeading] }}</div>
            </div>
            <!-- <mat-card-content>
              <p class="cardtext">{{ card?.[cardsObj?.description] }}</p>
            </mat-card-content> -->

            <div class="image-container">
              <img [src]="[cardsObj?.imagePath]" alt="Card image" />
            </div>



            <div class="row footercard">
              <div class="col-4 statusclass">{{ card?.[cardsObj?.actionAreaLeft] }}</div>
              <div class="col-4 timeclass">{{ card?.[cardsObj?.actionAreaMid] }}</div>
              <div class="col-4 action">

                <button mat-icon-button [matMenuTriggerFor]="menu1">
                  <mat-icon>more_vert</mat-icon>
                </button>


              </div>
            </div>
            <mat-menu #menu1="matMenu" style="width: 100px;">
              <button mat-menu-item (click)="onView(card)"> <i class="fa fa-eye tableicon"></i> View</button>
              <button mat-menu-item (click)="onUpdate(card)"><i class="fa fa-edit tableicon"></i> Update</button>
              <button mat-menu-item (click)="onDelete(card)"><i class="fa fa-trash tableicon"></i> Delete</button>
            </mat-menu>


          </mat-card>

        </div>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <div class="pagination-container">
          <app-pagination [currentPage]="currentPage" [totalItems]="totalItems" [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions" (pageChange)="onPageChange($event)"
            (onPagesizechange)="Pagesizechange($event)"></app-pagination>
        </div>
      </mat-card>
    </mat-card>
  </div>
</div>
